import ar_AR from './ar-AR.json'
import da_DK from './da-DK.json'
import el_GR from './el-GR.json'
import en_US from './en-US.json'
import es_LA from './es-LA.json'
import fr_FR from './fr-FR.json'
import hu_HU from './hu-HU.json'
import ja_JP from './ja-JP.json'
import nb_NO from './nb-NO.json'
import pl_PL from './pl-PL.json'
import pt_PT from './pt-PT.json'
import ru_RU from './ru-RU.json'
import th_TH from './th-TH.json'
import vi_VN from './vi-VN.json'
import zh_HK from './zh-HK.json'
import cs_CZ from './cs-CZ.json'
import de_DE from './de-DE.json'
import en_GB from './en-GB.json'
import es_ES from './es-ES.json'
import fr_CA from './fr-CA.json'
import he_IL from './he-IL.json'
import id_ID from './id-ID.json'
import it_IT from './it-IT.json'
import ko_KR from './ko-KR.json'
import nl_NL from './nl-NL.json'
import pt_BR from './pt-BR.json'
import ro_RO from './ro-RO.json'
import sv_SE from './sv-SE.json'
import tr_TR from './tr-TR.json'
import zh_CN from './zh-CN.json'
import zh_TW from './zh-TW.json'

export default {
  'ar-AR': ar_AR,
  'da-DK': da_DK,
  'el-GR': el_GR,
  'en-US': en_US,
  'es-LA': es_LA,
  'fr-FR': fr_FR,
  'hu-HU': hu_HU,
  'ja-JP': ja_JP,
  'nb-NO': nb_NO,
  'pl-PL': pl_PL,
  'pt-PT': pt_PT,
  'ru-RU': ru_RU,
  'th-TH': th_TH,
  'vi-VN': vi_VN,
  'zh-HK': zh_HK,
  'cs-CZ': cs_CZ,
  'de-DE': de_DE,
  'en-GB': en_GB,
  es: es_LA,
  pt: pt_BR,
  en: en_US,
  'es-ES': es_ES,
  'fr-CA': fr_CA,
  'he-IL': he_IL,
  'id-ID': id_ID,
  'it-IT': it_IT,
  'ko-KR': ko_KR,
  'nl-NL': nl_NL,
  'pt-BR': pt_BR,
  'ro-RO': ro_RO,
  'sv-SE': sv_SE,
  'tr-TR': tr_TR,
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
}
